import React,{useState} from "react";
import { Tag } from "primereact/tag";
import NavBar from "../component/NavBar";
import { WizardAppartamentoVilla } from "../component/WizardAppartamentoVilla";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga4";

const ChiSiamo = () => {
  const [tipologia, setTipologia] = useState("")
  const history = useHistory()
  ReactGA.send({ hitType: "pageview", page: "/chisiamo", title: "Chi Siamo" });
  const [visiblePreventivo, setVisiblePreventivo] = useState(false)
  const openWizardPreventivo = (tipologia) => {
    setVisiblePreventivo(true);
    setTipologia(tipologia);
  };



  return (
    <>
    <div>
      <NavBar goToContatti={() => history.push("/home#contatti")} openPreventivo={(tipologia) => openWizardPreventivo(tipologia)} />
      <div className="surface-section px-4  md:px-6 lg:px-8">
        <div className="text-600 text-sm mb-3">
          <span className="font-bold">Febbraio 11, 2025</span>
        </div>
        <div
          className="border-blue-600 font-medium text-2xl p-3 mb-3 text-900"
          style={{ borderLeft: "8px solid" }}
        >
          Chi siamo
        </div>

        <div className="mb-5">
          <Tag value="ristrutturazione" className="mr-2" />
          <Tag value="edilizia" severity="success" className="mr-2" />
          <Tag value="innovazione" severity="warning" />
        </div>
        <div className="line-height-3 text-lg text-700 mb-4">
          Siamo un team appassionato e dedicato di professionisti
          delle ristrutturazioni con sede in Lombardia, al servizio soprattutto
          della provincia di Milano. Con oltre 15 anni di esperienza nel
          settore, ci siamo guadagnati la reputazione di essere tra le migliori
          aziende di ristrutturazione della regione. Il nostro obiettivo è
          trasformare i vostri sogni di casa ideale in una splendida realtà.
        </div>
        
        <div className="text-2xl text-900 mb-4">La Nostra Mission</div>
        <div className="line-height-3 text-lg text-700 mb-4">
          La nostra missione è offrire soluzioni di ristrutturazione su misura
          che superino le aspettative dei nostri clienti. Ci impegniamo a
          fornire risultati impeccabili, lavorando con passione, competenza e un
          occhio attento per i dettagli. Ogni progetto è un'opportunità per noi
          di dimostrare il nostro impegno verso la qualità e l'eccellenza.
        </div>
       
        <div className="text-center mb-4">
          <img
            src="assets/immagini/hero4.webp"
            alt="content-1"
            width="20%"
            height="20%"
            className=" border-round"
          />
         
        </div>

        <div className="text-2xl text-900 mb-4">Cosa Facciamo</div>
        <div className="line-height-3 text-lg text-700 mb-4">
          Specializzati nelle ristrutturazioni di appartamenti, ville e locali
          commerciali, offriamo una vasta gamma di servizi per soddisfare ogni
          esigenza di rinnovamento. Che tu stia cercando di trasformare il tuo
          spazio abitativo, creare un ambiente lussuoso nella tua villa o
          rinnovare il tuo locale commerciale per attirare nuovi clienti, siamo
          qui per aiutarti a realizzare la tua visione.
        </div>

        <div className="text-2xl text-900 mb-4">La Nostra Squadra</div>
        <div className="line-height-3 text-lg text-700 mb-4">
          Al centro della nostra azienda c'è una squadra di sei operai altamente
          qualificati e dedicati. Ogni membro del nostro team porta con sé anni
          di esperienza nel settore delle ristrutturazioni e una passione per
          l'artigianato di alta qualità. Siamo un gruppo coeso, collaborativo e
          orientato ai risultati, sempre pronti a superare le sfide e a
          garantire risultati straordinari.
        </div>
        <div className="text-2xl text-900 mb-4">Il Nostro Impegno</div>
        <div className="line-height-3 text-lg text-700 mb-4">
          Ci impegniamo a garantire un servizio di ristrutturazione
          professionale, affidabile e trasparente. Collaboriamo strettamente con
          i nostri clienti per capire le loro esigenze e fornire soluzioni su
          misura che rispettino tempi e budget concordati. La nostra priorità è
          la vostra soddisfazione e lavoriamo duramente per assicurarci che ogni
          progetto sia completato con successo e senza stress.
        </div>

        <div className="text-2xl text-900 mb-4">Contattaci</div>
        <div className="line-height-3 text-lg text-700 mb-4">
          Se stai pensando di ristrutturare il tuo spazio, non esitare a
          contattarci. Saremo lieti di discutere delle tue idee, fornirti una
          consulenza personalizzata e aiutarti a trasformare il tuo ambiente in
          qualcosa di straordinario. Con noi, puoi contare su un
          partner di fiducia per tutti i tuoi progetti di ristrutturazione.
        </div>
      </div>
    </div>
    {visiblePreventivo && (
            <WizardAppartamentoVilla
              tipologia={tipologia}
              onExit={() => setVisiblePreventivo(false)}
            />
          )}
          </>
  );
};
export default ChiSiamo;
